import feather from 'feather-icons'

export function statusFormatter(cell, translator, who) {
    const data = cell.getData()

    const activityIcon = feather.icons[
        data.active === true ? 'check-circle' : 'x-circle'
    ].toSvg({
        class: 'block mx-auto mr-3',
        width: 20,
        height: 20
    })

    const activityTooltip = translator(
        data.active === true ? 'common.active' + who : 'common.notActive' + who
    )

    const visibilityIcon = feather.icons[
        data.visible === true ? 'eye' : 'eye-off'
    ].toSvg({
        class: 'block mx-auto',
        width: 20,
        height: 20
    })

    const visibilityTooltip = translator(
        data.visible === true ? 'common.visible' + who : 'common.notVisible' + who
    )

    return `<div class="flex items-center justify-center" title="${activityTooltip}">${activityIcon}</div> <div class="flex items-center justify-center" title="${visibilityTooltip}">${visibilityIcon}</div>`
}
